var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('w-datepicker',{staticClass:"form-group",attrs:{"model":_vm.schema.date}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }